export default __webpack_public_path__ + "static/media/lfc.de1a8697.jpg";